import React, { useState } from 'react';
import { Justify, Form, Input, Button, Modal, Checkbox } from 'tea-component';
import * as service from '@/pages/home/services/login';
import { visRegisterWeb, isEmptyValue, isValidGsv } from '../_config/common';
import { MIN_PASSWORD_LEN, MAX_PASSWORD_LEN } from '../_config/constant';
import { useIntl } from 'umi';
import { encryptedInfo } from '@/pages/home/utils/frontEncryption';
import { ENV } from '@/pages/home/_config/config';

export default function AccountnameLogin(props: any) {
  const {
    getRegister,
    oaLoading,
    onLoginSuccess,
    login14Days,
    setLogin14Days,
    onError = () => console.log,
  } = props;
  const { formatMessage } = useIntl();

  // 用户名
  const [statusName, setStatusName] = useState<string | null>(null);
  const [valueName, setValueName] = useState<string>('');
  const [successName, setSuccessName] = useState(false);

  // 密码
  const [statusPadssword, setStatusPadssword] = useState<string | null>(null);
  const [valuePadssword, setValuePadssword] = useState<string>('');
  const [successPadssword, setSuccessPadssword] = useState(false);
  // 忘记密码弹窗
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const open = () => setVisible(true);
  const close = () => setVisible(false);

  const onNameChangClick = (val: string) => {
    setValueName(val);
  };
  const onNameBuleClick = () => {
    if (isEmptyValue(valueName)) {
      setStatusName('dbh_login_no_account_enter');
      setSuccessName(false);
    } else if (isValidGsv(valueName)) {
      setStatusName('dbh_login_account_format_gsv');
      setSuccessName(false);
    } else {
      setStatusName(null);
      setSuccessName(true);
    }
    // 浏览器记录账户密码时，账户更新同时验证密码
    if (valuePadssword) {
      onPadsswordBuleClick();
    }
  };
  const onPadsswordChangClick = (val: string) => {
    setValuePadssword(val);
  };
  const onPadsswordBuleClick = () => {
    if (!valuePadssword) {
      setStatusPadssword('dbh_login_no_password_enter');
      setSuccessPadssword(false);
    } else if (isValidGsv(valuePadssword)) {
      setStatusPadssword('dbh_login_format_gsv');
      setSuccessPadssword(false);
    } else {
      setStatusPadssword(null);
      setSuccessPadssword(true);
    }
  };

  const getStatusPadsswordId = (id: string) => {
    if (id === 'dbh_login_password_format') {
      return formatMessage(
        { id: 'dbh_login_password_format' },
        { min: MIN_PASSWORD_LEN, max: MAX_PASSWORD_LEN },
      );
    }
    return formatMessage({ id });
  };

  const onDataBrainAccountLogin = async () => {
    if (loading) {
      return;
    }
    onNameBuleClick();
    onPadsswordBuleClick();
    if (!successPadssword || !successName) {
      return;
    }

    try {
      setLoading(true);
      // 密码加密
      const turnPassword = await encryptedInfo(valuePadssword);
      const params = {
        login_type: 'Basic',
        user_name: valueName,
        password: turnPassword,
        login_un_white_list: ['dev','test'].includes(ENV) ? false : true, // 账号登录开启白名单, 开发环境不开启
      } as any;
      if (login14Days) {
        params.login14Days = true;
      }
      await service.login(params);
      await onLoginSuccess();
      // setLoading(false);  登陆成功不需要把loading置false
    } catch (err: any) {
      if (err?.code === 4007) {
        // 4007 账号或密码错误
        setStatusName('dbh_login_error_no_message');
        setSuccessName(false);
        setStatusPadssword('dbh_login_error_username');
        setSuccessPadssword(false);
      } else {
        onError(err?.msg, err?.code);
      }
      setLoading(false);
    }
  };

  return (
    <div className="login-cont-accountname">
      <div className="login-cont-title">
        {formatMessage({ id: 'dbh_login_account_login' })}
      </div>
      <div className="login-cont-account">
        {/* 账号登录 */}
        <Form.Item
          label={formatMessage({ id: 'dbh_login_account_name' })}
          status={
            /* successName ? 'success' : */ statusName ? 'error' : undefined
          }
          message={statusName ? formatMessage({ id: statusName }) : undefined}
        >
          <Input
            placeholder={formatMessage({
              id: 'dbh_login_account_name_placeholder',
            })}
            value={valueName}
            onChange={(val) => {
              onNameChangClick(val);
            }}
            onBlur={onNameBuleClick}
          />
        </Form.Item>

        <Form.Item
          label={formatMessage({ id: 'dbh_login_password' })}
          status={
            /* successPadssword ? 'success' : */ statusPadssword
              ? 'error'
              : undefined
          }
          message={
            statusPadssword ? getStatusPadsswordId(statusPadssword) : undefined
          }
        >
          <Input
            type="password"
            placeholder={formatMessage({
              id: 'dbh_login_password_placeholder',
            })}
            value={valuePadssword}
            onChange={(val) => {
              onPadsswordChangClick(val);
            }}
            onBlur={onPadsswordBuleClick}
          />
        </Form.Item>
      </div>
      <Checkbox
        className="db-login-14days-box"
        value={login14Days}
        onChange={(value) => {
          setLogin14Days(value);
        }}
        display="block"
      >
        {formatMessage({ id: 'dbh_14_days_login' })}
      </Checkbox>
      <div className="login-cont-from-btn">
        <Button
          type="primary"
          onClick={() => {
            onDataBrainAccountLogin();
          }}
          loading={loading || oaLoading}
        >
          {formatMessage({ id: 'dbh_login' })}
        </Button>
      </div>
      <Justify
        left={
          visRegisterWeb.includes(window.location.host) && (
            <Button
              type="link"
              className="login-cont-from-info"
              onClick={getRegister}
            >
              <span>{formatMessage({ id: 'dbh_login_register' })}</span>
            </Button>
          )
        }
        right={
          <Button type="link" className="login-cont-from-info">
            <span onClick={open}>
              {formatMessage({ id: 'dbh_login_is_forget_password' })}
            </span>
          </Button>
        }
      ></Justify>

      {/* 忘记密码弹窗 */}
      <div className="modal">
        <Modal visible={visible} onClose={close}>
          <Modal.Body>
            <div className="modal-title">
              {formatMessage({ id: 'dbh_login_forget_password' })}
            </div>
            <div className="modal-text">
              {/* Please contact <span>ivyyfchen</span> to get your new account info. */}
              {formatMessage(
                {
                  id: 'dbh_login_forget_password_desc',
                },
                {
                  name: <span>ivyyfchen</span>,
                },
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="primary" onClick={close}>
              {formatMessage({ id: 'dbh_login_ikonw' })}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
